import { Box, Tabs } from '@dixa/lib-shared-habla';
import {
  floatingLinkActions,
  floatingLinkSelectors,
  FloatingLinkType,
} from 'lib-knowledge-document-structure';

import { EditArticleLinkForm } from './editArticleLinkForm';
import { EditElementLinkForm } from './editElementLinkForm';
import s from './editLinkTabs.module.scss';
import { EditURLLinkForm } from './editURLLinkForm';

export const EditLinkTabs = (): JSX.Element => {
  const selectedTab = floatingLinkSelectors.linkType();
  const setSelectedTab = (tab: string) => {
    floatingLinkActions.linkType(tab as FloatingLinkType);
  };

  return (
    <div className={s['root']}>
      <div className={s.tabsHeader}>
        <Tabs
          selectedId={selectedTab}
          onChange={setSelectedTab}
          tabClassName={s.tabs}
          tabs={[
            { id: 'url', label: 'URL' },
            { id: 'article', label: 'Article' },
            { id: 'anchor', label: 'Heading' },
          ]}
        ></Tabs>
      </div>

      <Box padding="100">
        {selectedTab === 'url' && <EditURLLinkForm />}
        {selectedTab === 'article' && <EditArticleLinkForm />}
        {selectedTab === 'anchor' && <EditElementLinkForm />}
      </Box>
    </div>
  );
};
